import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { DETAILS_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useDetailsSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useDetailsItemCarInPrepare() {
  const { startListen } = useWebSocketStore()
  const { updateDetailsCarData } = useUpdateCar()

  const carInPrepare = () => {
    startListen({
      eventName: 'premium.CAR_IN_PREPARE',
      callbackName: DETAILS_SOCKET_CALLBACK,
      callback: (event) => {
        const { carId } = event.context

        updateDetailsCarData(carId, (data) => {
          return {
            ...data,
            stage: 'IN_PREPARATION',
          }
        })
      },
    })
  }

  return { carInPrepare }
}
